"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CarrierAccount {
}
exports.CarrierAccount = CarrierAccount;
//# sourceMappingURL=CarrierAccount.js.map